<template>
  <footer class="footer4-footer7 thq-section-padding">
    <div class="footer4-max-width thq-section-max-width">
      <div class="footer4-credits">
        <div class="thq-divider-horizontal">
        </div>
        <div class="footer4-row">
          <div class="footer4-container">
            <span class="thq-body-small">© 2025 VLECAD®</span>
          </div>
          <div class="footer4-footer-links">
            <span class="footer4-text11 thq-body-small">
              <div class="cssContents">
                <span class="cssInlineBlock showHand" @click="privacy">Privacy Policy</span>
              </div>
            </span>
            <span class="thq-body-small">
              <div class="cssContents">
                <span class="cssInlineBlock showHand" @click="terms">Terms and Conditions</span>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    privacy() {
      console.log("privacy");
      this.$router.push("/privacy");
    },
    terms() {
      console.log("terms");
      this.$router.push("/terms");
    }
  }
}
</script>


<style scoped>
.showHand {
  cursor: pointer;
}

.footer4-footer7 {
  width: 100%;
  height: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.footer4-max-width {
  gap: var(--dl-layout-space-threeunits);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.footer4-credits {
  gap: var(--dl-layout-space-twounits);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.footer4-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.footer4-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.footer4-footer-links {
  gap: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.footer4-text11 {
  fill: var(--dl-color-theme-neutral-dark);
  color: var(--dl-color-theme-neutral-dark);
}
</style>
